const SET_CATEGORIES = 'SET_CATEGORIES';
const SET_CATEGORIES_REFACTORED = 'SET_CATEGORIES_REFACTORED';
const SET_SELECTED_CATEGORY = 'SET_SELECTED_CATEGORY';
const SET_CATEGORIES_ALL = 'SET_CATEGORIES_ALL';

export { SET_CATEGORIES, SET_CATEGORIES_REFACTORED, SET_SELECTED_CATEGORY, SET_CATEGORIES_ALL };
